import React from 'react';
import PropTypes from 'prop-types';
import ChevronLeft from '@fabric-ds/icons/dist/24/chevron-left.svg';

const BackToProjectButton = ({ parentFinnkode, podletPath }) => {
    if (parentFinnkode) {
        return (
            <button
                type="button"
                className="button button--secondary flex min-w-full my-16"
                onClick={() => {
                    window.location.href = `${podletPath}?finnkode=${parentFinnkode}`;
                }}
            >
                <ChevronLeft width={24} height={24} />
                Gå til prosjektannonsen
            </button>
        );
    }
    return null;
};

BackToProjectButton.propTypes = {
    parentFinnkode: PropTypes.number.isRequired,
    podletPath: PropTypes.string.isRequired,
};

export default BackToProjectButton;
